module.exports = __webpack_public_path__ + "img/about-ch3-parisagreement.e09ff7e9.svg";